<template>
    <Row>
        <Column :width="15" v-if="ready">
            <Box>
                <Row>
                    <Column :width="row.labelWidth()">
                        <Box>
                            <CheckboxUpdateCell
                                :data="checkboxRow().data"
                                v-on:withValue="withValue"/>
                        </Box>
                    </Column>
                    <Column :width="15 - row.labelWidth()"></Column>
                    <Column>
                        <Box v-if="showChildren" :key="redraw">
                            <Row v-for="(child, childIndex) in children" :key="childIndex" >
                                <ChildCellFactory :rowData="child.data" :showMissingRequirements="showMissingRequirements"
                                    v-on:withValue="withValue"
                                    v-on:withEnterPressed="withEnterPressed"
                                    v-on:withButtonPressed="withButtonPressed" />
                            </Row>
                        </Box>
                    </Column>
                </Row>
            </Box>
        </Column>
    </Row>
</template>

<script>

import { mapGetters } from 'vuex'

import MC from "@/domain/session/MC.js";

import ContentUtils from '@/utils/ContentUtils.js';

import Box from "@/portals/shared/library/box/Box.vue";
import Row from "@/portals/shared/library/box/Row.vue";
import Column from "@/portals/shared/library/box/Column.vue";

import CheckboxChildrenRow from "./CheckboxChildrenRow.js";
import CheckboxUpdateCell from './CheckboxUpdateCell.vue';
import CheckboxUpdateRow from './CheckboxUpdateRow.js';

export default {
    name: 'checkbox-children-cell',
    components: {
        Row, Column, Box,
        CheckboxUpdateCell,
        ChildCellFactory: () => import("@/portals/shared/cell/CellFactory.vue")
    },
    props: {
        showMissingRequirements: { type: Boolean, default: false },
        data: null,
    },
    data() {
        return {
            row: new CheckboxChildrenRow(),
            MC: new MC(),
            ContentUtils: ContentUtils,
            ready: false,
            showChildren: false,
            children: [],
            redraw: 1,
        };
    },
    computed: {
        ...mapGetters([
            'domain',
        ]),
        rowData: function () {
            return this.row;
        },
    },
    mounted: function () {
        this.row.data = this.data;
        this.showChildren = this.row.defaultValue();
        console.log("showChildren", this.showChildren); //eslint-disable-line no-console
        this.children = this.row.children();
        this.ready = true;
    },
    methods: {
        withValue: function (valueData) {
            if (valueData["field"] === this.rowData.field()) {
                this.showChildren = valueData["value"];
                this.redraw = this.redraw + 1;
            }
            this.$emit('withValue', valueData);
        },

        withButtonPressed: function (buttonData) {
            this.$emit('withButtonPressed', buttonData);
        },

        withEnterPressed(keyData) {
            this.$emit("withEnterPressed", keyData);
        },

        checkboxRow: function () {
            let row = new CheckboxUpdateRow();
            row.withName(this.row.name());
            row.withDefaultValue(this.showChildren);
            row.withField(this.row.field());
            row.withWidth(15);

            return row;
        },
    }
}

</script>